export const buildTime = '2026-10-19 07:29:30 UTC';
